import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useState, useEffect } from "react";
import useQueryMutation from "hooks/useQueryMutation";
import { useQueryClient } from "@tanstack/react-query";
import useFetch from "hooks/useFetch";
import { useAuth } from "contexts/AuthContext";
import { useParams } from "react-router-dom";
import _sortBy from "lodash/sortBy";

export default function NewProjectButton() {
  const { currentUser } = useAuth();
  const queryClient = useQueryClient();
  const { customerId: customerIdParam } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [name, setName] = useState("");
  const [customerId, setCustomerId] = useState(customerIdParam || 0);

  useEffect(() => {
    setCustomerId(customerIdParam || 0);
  }, [customerIdParam]);

  const { data: customerRes } = useFetch("/customer");

  const { mutate: createProject, isPending } = useQueryMutation(
    "/project",
    "POST",
    {
      onSuccess: () => {
        setIsOpen(false);
        setName("");
        setCustomerId(0);
        queryClient.invalidateQueries({ queryKey: ["/project"] });
      },
    }
  );

  const disabled =
    !name.trim() || isPending || customerId === 0 || !currentUser;

  const handleSave = () => {
    if (disabled) return;
    createProject({
      name,
      customer_id: customerId,
      created_by: currentUser?.email || currentUser?.uid || "[unnamed]",
    });
  };

  const sortedCustomers = _sortBy(customerRes?.customers || [], (v) =>
    v.name.toLowerCase()
  );

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={() => setIsOpen(true)}
      >
        NEW PROJECT
      </Button>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>New Project</DialogTitle>
        <DialogContent>
          <FormControl variant="standard" sx={{ width: "100%" }}>
            <Select
              labelId="group-select-label"
              id="group-select"
              value={customerId}
              onChange={(e) => setCustomerId(e.target.value)}
              label="Select group"
            >
              <MenuItem value={0}>
                <em>Select group</em>
              </MenuItem>
              {sortedCustomers.map((customer) => (
                <MenuItem key={customer.id} value={customer.id}>
                  {customer.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Project name"
            type="text"
            fullWidth
            variant="standard"
            maxLength={32}
            value={name}
            required
            disabled={isPending}
            onChange={(e) => setName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpen(false)}>CANCEL</Button>
          <Button onClick={handleSave} disabled={disabled}>
            {isPending ? "Saving..." : "SAVE"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
